import React from 'react'
import { Image, Spin, Popconfirm } from 'antd'
import { EyeOutlined, DeleteOutlined } from '@ant-design/icons'
import { ExpandableTableCard, ImageContainer } from './styledComponents'
import { fallback } from '$utils'
import { useTranslation } from 'react-i18next'

const Partimage = ({
  part_url,
  deleteStl,
  handlePreview,
  setFileList,
  isDeleting,
}) => {
  const { t } = useTranslation()

  const replaceStl = (e) => {
    e.stopPropagation()
    deleteStl()
    setFileList([])
  }

  return (
    <ExpandableTableCard>
      <ImageContainer>
        <div onClick={handlePreview}>
          <Image
            src={part_url}
            fallback={fallback}
            width="100%"
            preview={false}
          />
          <div className="overlay">
            <Popconfirm
              title={t('part_3d_file_upload.delete_stl_confirm_title')}
              onConfirm={replaceStl}
              onCancel={(e) => e.stopPropagation()}
              okText={t('part_3d_file_upload.delete_stl_confirm_ok')}
              cancelText={t('part_3d_file_upload.delete_stl_confirm_cancel')}
              placement="top"
              disabled={isDeleting}
            >
              <div onClick={(e) => e.stopPropagation()}>
                {isDeleting ? (
                  <Spin />
                ) : (
                  <>
                    <DeleteOutlined /> {t('button.delete')}
                  </>
                )}
              </div>
            </Popconfirm>
            <EyeOutlined /> {t('Preview')}
          </div>
        </div>
      </ImageContainer>
    </ExpandableTableCard>
  )
}

export default Partimage
